var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Header } from '@s7/header';
import { sso } from '../../../shared/self';
export var HeaderProfileUnauthorized = function (props) { return (React.createElement(Header.Profile, __assign({}, props, { href: sso.getRedirectURI({
        redirectUri: window.location.href
    }), as: "a" }))); };
